import { Option } from './option'

export class OptionProperties {
  static getOptionPicture(mainOption?: {
    picture?: Pick<NonNullable<Option['picture']>, 'path'>
  }): string {
    return mainOption?.picture?.path ?? '/profile-default.jpg'
  }
}
